if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  console.log("eventName",eventName);
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
// function giftFn(){
//    const Enabled_reach_Product=theme.settings.isgiftonminimumspendenabled;
//   if((eventName.includes("cart") || eventName.includes("line-item"))&&Enabled_reach_Product&&document.getElementById("Cart-Drawer").querySelector(".product-cart-item--container")){
//     //data-cart-total
//     let CartTotal=document.getElementById("Cart-Drawer").querySelector(".product-cart-item--container").getAttribute('data-cart-total')?document.getElementById("Cart-Drawer").querySelector(".product-cart-item--container").getAttribute('data-cart-total'):0;
//     let giftProductId;
//     console.log("CartTotal",CartTotal)
//     let giftonminimumspendList=theme.settings.giftonminimumspendList.sort((a, b) => {
//         return parseFloat(a.minpurchaseamount) - parseFloat(b.minpurchaseamount);
//     });
//     console.log("giftonminimumspendList",giftonminimumspendList)
//     for(const item of giftonminimumspendList){
//       console.log("==tem.minpurchaseamount==",item.minpurchaseamount)
//        if(Number(CartTotal)>=Number(item.minpurchaseamount)){
//           giftProductId=item.freegift
//        }
//     }
//     console.log("==CartTotal==",CartTotal)
//     console.log("==giftProductId==",giftProductId)
//     if(giftProductId){
//       const parts = giftProductId.split('/');
//       pureProductId = parts[parts.length - 1];
//       const formData = {
//           'items': [
//               {
//                   'id': pureProductId,
//                   'quantity':1
//               }
//           ]
//       }
//       fetch(window.Shopify.routes.root + 'cart/add.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(formData)
//       }).then((response) => {
//         theme.settings.isHasFreeGift=true;
//         new CartDrawer().refresh()
//       })
//    }else{
//     console.log("No gift product")
//    }
//   }
// }
window.addEventListener('line-item:change:start', function () {
  
})
/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

      this.validateQtyRules();
    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }

      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      function getValueFromKey(obj, key) {
        let objKey = Object.keys(obj).find((k) => k.toLowerCase() === key.toLowerCase());
        if (objKey) {
            return {
              isBgColor:true,
              isOnlyColor:obj[objKey].includes(".")?false:true,
              val:obj[objKey]
            };
        } else {
            return {
              isBgColor:false,
              val:key
            };
        }
      } 
      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', function () {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
        let getColorName = swatch.querySelector('span').querySelector('tc')?swatch.querySelector('span').querySelector('tc').innerHTML.trim():swatch.querySelector('span').innerHTML.trim();
        const colorValue = getValueFromKey(theme.settings.custom_colors, getColorName);
        if(colorValue.isBgColor){ 
          if(colorValue.isOnlyColor){
            swatch.style=`--option-color: ${colorValue.val};`
            return
          }
          swatch.style=`--option-color-image: url('//phomemo.com/cdn/shop/files/${colorValue.val}');`
        }else{
          swatch.style=`--option-color: ${colorValue.val};`
        }
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);
      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);
      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
        //this.checkDiscord()
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');

        dispatchCustomEvent('cart-drawer:open');
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      const element = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
      return element ? element.innerHTML : '';
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super();
      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true');
      this.button = this.querySelector('button');
      this.id = this.dataset.id;
      this.url = this.dataset.url;
    }
    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners();
      }
    }
    setEventListeners() {
      this.button.addEventListener('click', this.addToCart.bind(this));
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    addToCart() {
      this.button.classList.add('loading');
     
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute('aria-disabled', true);
      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);
      formData.append('id', this.id);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        });
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));
      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      const element = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
      return element ? element.innerHTML : '';
    }
  }
  customElements.define('product-card-small', ProductCardSmall);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            if (document.body.classList.contains('open-cc--product')) {
              document.body.classList.remove('open-cc--product');

              setTimeout(() => {
                document.querySelector('#Product-Drawer-Content').innerHTML = '';
              }, 260);
            } else {
              if (panel.classList.contains('cart-drawer')) {
                document.getElementById('cart-drawer-toggle').focus();
              }
              document.body.classList.remove('open-cc');
            }
            panel.classList.remove('active');
            this.popupHandel()
          });
        }
      }
    });
    cc.addEventListener('click', (e) => {
      let panel = document.querySelector('.side-panel.active');
      if (panel) {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
        this.popupHandel()
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    if (document.body.classList.contains('open-cc--product')) {
      document.body.classList.remove('open-cc--product');
      setTimeout(() => {
        document.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);
    } else {
      document.body.classList.remove('open-cc');
    }
    this.popupHandel()
  }
  popupHandel(){
    if(!document.querySelector('.cart-drawer__empty-cart')&&!getCookie("cart-popup")){
      setTimeout(()=>{
        if(document.getElementById("main-popup-section")){
          document.getElementById("main-popup-section").style.display = "flex"
        }
      },1500)
    }
  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {
  constructor() {
    this.container = document.getElementById('Cart-Drawer');
    if (!this.container) {
      return;
    }
    let button = document.getElementById('cart-drawer-toggle');
    // Add functionality to buttons
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      this.container.classList.add('active');
      this.container.focus();
      dispatchCustomEvent('cart-drawer:open');
    });
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));
    this.notesToggle();
    this.removeProductEvent();
    // Terms checkbox
    this.termsCheckbox();
    let debounceTimer;
    this.noteTextarea=document.getElementById('mini-cart__notes')
    let That=this;
    if (this.noteTextarea) {
      this.noteTextarea.addEventListener('input', () => {
          clearTimeout(this.debounceTimer);
          this.debounceTimer = setTimeout(() => {
              That.saveNotes(); 
          }, 1000); 
      });
  }
    
  }

  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');
    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');
        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    const element = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return element ? element.innerHTML : '';
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout');
    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateQuantity(line, quantity) {
    this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }else{
            this.refresh()
          }
        }));
        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
  }
  async applyDiscount(code) {
    const resp=await fetch('/payments/config', { method: 'GET' })
    const resp1=await fetch('/cart.js')
    let discountApplyUrl = '/discount/' + code + '?v=' + Date.now() + '&redirect=/checkouts/';
    await fetch(discountApplyUrl, {})
    await this.getCartTotal()
  }
  getCartTotal(){
    const quantity= document.querySelector('.side-panel-content .qty').value;
    this.updateQuantity(1,quantity)
  }
  refresh() {
    let sections = 'cart-drawer,cart-bubble';
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }));
        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
      });
  }
  checkDiscord(){
    let cart_form = this.container.querySelector('#cart-drawer-form');
    if(cart_form){
        let discountCode=document.getElementById('cart-drawer-discount')?document.getElementById('cart-drawer-discount').value:'';
        cart_form.action = discountCode?"/cart?discount="+discountCode:"/cart";
    }
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select');
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);

    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + 12}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".thb-widget-title.collapsible").forEach((button) => {
      button.addEventListener("click", (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list'),
      };
      this.autoClose = this.dataset.autoClose;
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this));
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.detailsements.panel.querySelectorAll('button').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false');
      this.classList.remove('custom-select--active');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.detailsements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.detailsements.input.value = event.currentTarget.dataset.value;
      this.detailsements.input.dispatchEvent(new Event('change'));
      this.detailsements.button.querySelector('.custom-select--text').textContent = event.currentTarget.textContent;
      if (this.detailsements.form) {
        this.detailsements.form.dispatchEvent(new Event('input'));
      }
      if (this.autoClose) {
        this.classList.remove('custom-select--active');
      }
    }

    toggleSelector(event) {
      event.preventDefault();
      this.classList.toggle('custom-select--active');
      if (this.classList.contains('custom-select--active')) {
        this.detailsements.button.focus();
        this.detailsements.button.setAttribute('aria-expanded', (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString());
      } else {
        this.hidePanel();
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('custom-select', CustomSelect);
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('input[name="locale_code"], input[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
      this.isOnlyOpen= this.getAttribute('data-isOnlyOpen');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

   open() {
        if (this.isOnlyOpen) {
          document.querySelectorAll('.product__accordion').forEach((details) => {
            details.querySelector('details').open = false;
          });
        }

        setTimeout(() => {
          // Apply a fixed height on the element
          this.details.style.height = `${this.details.offsetHeight}px`;
          // Force the [open] attribute on the details element
          this.details.open = true;

          // Wait for the next frame to call the expand function
          window.requestAnimationFrame(() => {
            this.expand();
            this.details.scrollIntoView({
              behavior: 'smooth', 
              block: 'center',    
              inline: 'nearest'  
            });
          });
        }, 60);
      }
    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');

      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');

      setTimeout(() => {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);



        this.body.classList.add('open-cc--product');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider');

          slider.reInit();
          window.dispatchEvent(new Event('resize'));
        }, 100);

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {

  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path');
    this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: "0%",
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%'
        }
      });
    });
  }

}
function consentGrantedAdStorage() {
  setCookie("accept_cookies", "granted", 30,'/');
  $("#accept_cookies").hide()
  gtag('consent', 'update', {
    'ad_storage': 'granted',
    'ad_user_data': 'granted',
    'ad_personalization': 'granted',
    'analytics_storage': 'granted'
  });
  if(customElements.get('product-add-to-cart-sticky')) {
    let acH=$("#accept_cookies").height();
    $("product-add-to-cart-sticky").css("bottom",0)
  }
}
function hideAdStorage() {
  setCookie("accept_cookies", "denied", 30,'/');
  $("#accept_cookies").hide()
  if(customElements.get('product-add-to-cart-sticky')) {
    let acH=$("#accept_cookies").height();
    $("product-add-to-cart-sticky").css("bottom",0)
  }
}
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
function hasUtmParams() {
    const urlParams = new URLSearchParams(window.location.search);
    // const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    const utmParams = ['utm_term'];
    for (const param of utmParams) {
      if (urlParams.has(param)) {
        return true;
      }
    }
    return false;
  }
  
document.addEventListener('DOMContentLoaded', () => {

  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }
  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }

  let currentPath = window.location.pathname;
  if(currentPath=='/cart'){
    setCookie('view_cart','true',1);
  }else if(currentPath!=='/cart'&&getCookie('view_cart')&&!document.querySelector('.cart-drawer__empty-cart')&&!getCookie("cart-popup")){
    setTimeout(()=>{
    document.getElementById("main-popup-section").style.display = "flex";
    },1500)
  }
  //let isEuList=['fr','de','es','it','nl','be','pt','se','gr','ie','pl','cz','at','dk','hu','fi','cy','ro','hr','sk','si','mt','ee','bg','lv','lu','lt'].map(item=>item.toUpperCase());
  let isEuList=['DE','GB','FR','IT','CZ','ES','BE','NL','PL','SE','FI','DK','IE','LU','MC','CY','PT','AT','NO','HU','SK','SI','HR','MT','LT','BG','EE','GR','LV','RO','CH','IS','LI'].map(item=>item.toUpperCase());
  //let isEuList=['HU','FI'].map(item=>item.toUpperCase());
  if(isEuList.indexOf(Shopify.country)>-1&&!localStorage.getItem('is_ip_eu')&&document.getElementById("eu-popup-section")){
    document.getElementById("eu-popup-section").style.display = "flex";
  }
  
  if(document.getElementById("nps-popup-section")){
    const surveyIframe = document.getElementById('surveyIframe');
    const npsPopupContent = document.getElementById('nps_popup_content');
    const npsLoading = document.getElementById('nps_loading');
    const npsContainer = document.getElementById('nps-popup-container');
    const npsPopupIconTips = document.getElementById('nps-popup-icon-tips');
    function hasSubmitNps(){
      npsPopupContent.style.display = 'block';
      npsContainer.style.width = window.innerWidth<768 ? '90%':'auto';
      surveyIframe.style.display = 'none';
      npsPopupIconTips.style.display = 'none';
      npsContainer.style.height='auto';
      localStorage.setItem("is_nps_submit_20250314",true)
    }
    const messageHandler = event => {
        if (event.origin !== 'https://surveymars.com') return;
        if (event.data === 'submitSuccess') {
          hasSubmitNps()
        }
    };
    window.addEventListener('message', messageHandler);
    surveyIframe.onload = function() {
      npsLoading.style.display = 'none';
    };
    if(localStorage.getItem("is_nps_submit_20250314")){
      npsPopupIconTips.style.display = "none";
      hasSubmitNps()
    }
    document.getElementById('nps-popup-icon').style.transform="scale(1)";
  }
  // if (hasUtmParams()) {
  //   setTimeout(()=>{
  //     consentGrantedAdStorage();
  //   },getRandomInt(600, 1850))
  // }else if(!getCookie('accept_cookies')){
  if(!getCookie('accept_cookies')){
    $("#accept_cookies").show()
    if(customElements.get('product-add-to-cart-sticky')) {
      let acH=$("#accept_cookies").height();
      $("product-add-to-cart-sticky").css("bottom",$(window).width()>768?acH:acH+5)
    }
  }
  let faqBtn=$('.tabbed-content--content button');
  if(faqBtn&&faqBtn.length>0){
    for (let i = 0; i < faqBtn.length; i++) {
      faqBtn[i].addEventListener('click', function(event) {
             //let previousSibling = this.previousElementSibling;
             let nextSibling = this.nextElementSibling;
             if (nextSibling&&!nextSibling.classList.contains("pf-accordion-wrapper")) {
              nextSibling.style.display = nextSibling.style.display=='block'?'none':'block';
              nextSibling.toggle()
            }
         });
     }
  }
  
});
 function renderDiscounts(existingDiscounts, discountCodeValue) {
  console.log("==清空==")
      const body = JSON.stringify({
        discount: [],
        sections: new CartDrawer().getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          new CartDrawer().getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections && elementToReplace) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));
          this.querySelector('.cart-discounts--button').classList.remove('loading');
          if (parsedState.discount_codes.find((discount) => {
            return discount.code === discountCodeValue && discount.applicable === false;
          })) {
            setTimeout(() => {
              this.querySelector('.cart-discounts--error').removeAttribute('hidden');
            }, 300);
            return;
          }
        });
    }
  
async function applyDiscount(type,inputCode){
  let code=inputCode?inputCode:event.target.closest('.cart-sidebar-discount').querySelector('.discount-code-input').value;
  if(!code) return
  let applyBtn=event.target;
  if(applyBtn.classList.contains('apply-discount-btn')){
      applyBtn.innerHTML = "APPLYING <div class='loader'></div>";
      applyBtn.style.pointerEvents = 'none';
  }
  if(applyBtn.classList.contains('clear-discount-btn')){
      let ElDiv=event.target.closest('.cart-sidebar-discount').querySelector('.applied-discount-code-wrapper');
      event.target.closest('.cart-sidebar-discount').querySelector('.applied-discount-code').style.display='flex';
      ElDiv.innerHTML = "<div class='loader'></div>"
  }
  if(applyBtn.disabled){
      return
  }
  let newCartDrawer=type=='cartDrawer'?new CartDrawer():new Cart();
  await newCartDrawer.applyDiscount(code)
  applyBtn.disabled=false
}

function closeEuPopup(){
  document.getElementById("eu-popup-section").style.display = "none";
  localStorage.setItem("is_ip_eu",true)
}
function CloseNpsTips(event){
  event.stopPropagation();
  document.getElementById("nps-popup-icon-tips").style.display = "none";
}
function ToggleNpsPopup(type){
  document.getElementById("nps-popup-section").style.display = type?"flex":"none";
  if(type&&localStorage.getItem("is_nps_submit_20250314")){
    document.getElementById("nps_popup_content").style.display = "block";
    document.getElementById('nps_loading').style.display = "none";
    document.getElementById('surveyIframe').style.display = "none";
    return
  }
}
const copyText = async (val,el,textEl,applyDiscount=false) => {
  try {
    if(textEl){
      el.querySelector(textEl).innerHTML = "Copied"
    }else if(el){
      el.querySelector('small').style.display='flex';
    }else{
      document.getElementById("textCopied").style.display = "block";
    }
    if(applyDiscount){
      const body = JSON.stringify({
        discount: val,
      });
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
      .then((response) => {
        return response.text();
      })
    }
    if (navigator.clipboard && navigator.permissions) {
      await navigator.clipboard.writeText(val);
      return;
    }
   
   const textArea = document.createElement('textArea') 
   textArea.value = val 
   textArea.style.width = 0 
   textArea.style.position = 'fixed' 
   textArea.style.left = '-999px' 
   textArea.style.top = '10px' 
   textArea.setAttribute('readonly', 'readonly')
   document.body.appendChild(textArea) 
   textArea.select()
    const success = document.execCommand('copy');
    if (!success) {
      throw new Error('无法复制文本');
    }
    document.body.removeChild(textArea);
    
  } catch (err) {
    document.getElementById("textCopied").style.display = "block";
    document.getElementById("textCopied").innerHTML="Copy Failed!";
  }
};
function goLink(res){
 let goUrl=res;
  if(res==='https://eu.phomemo.com?utm_source=phomemo&utm_medium=web&utm_term=popop'){
    if(location.href.includes('utm_source=ggads')||location.href.includes('utm_source=bingads')
      ||location.href.includes('utm_source=fbads')||location.href.includes('utm_source=phomemo')){
      goUrl=location.href.replace('phomemo.com','eu.phomemo.com')
    }
    closeEuPopup()
  }
  location.href = goUrl;
}

function goNewLink(res){
  window.open(res);
}
function getCookie(name) {
  var start = document.cookie.indexOf(name + "=");
  var len = start + name.length + 1;
  if ((!start) && (name != document.cookie.substring(0, name.length))) {
    return null;
  }
  if (start == -1) return null;
  var end = document.cookie.indexOf(';', len);
  if (end == -1) end = document.cookie.length;
  return unescape(document.cookie.substring(len, end));
}
function setCookie(name, value, expires, path, domain, secure) {
  var today = new Date();
  today.setTime(today.getTime());
  if (expires) {
    expires = expires * 1000 * 60 * 60 * 24; //����cookie�Ĺ��ں�����
  }
  var expires_date = new Date(today.getTime() + (expires));
  document.cookie = name + '=' + escape(value) +
    ((expires) ? ';expires=' + expires_date.toGMTString() : '') + //expires.toGMTString()
    // ((path) ? ';path=' + path : '') +
    ((path) ? ';path=' + '/' : '/') +
    ((domain) ? ';domain=' + domain : '') +
    ((secure) ? ';secure' : '');
}

setTimeout(()=>{
  if(document.getElementById("nps-popup-section")&&!localStorage.getItem("is_nps_submit_20250314")){
    document.getElementById("nps-popup-icon-tips").style.display = "block";
  }
},60000)
function limitBuy(el){
  el.parentNode.parentNode.classList.add("show-limit-alert-tips")
  setTimeout(()=>{
    el.parentNode.parentNode.classList.remove("show-limit-alert-tips")
  },3000)
}
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}
document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {
      const target = event.target;
      if(target.classList.contains("userAgentLink")&&isIOS()){
        event.preventDefault();
        window.location.href = target.href
      }
    });
  function removePcClassesOnMobile() {
      if (window.innerWidth < 768) {
        const elements = document.querySelectorAll('[class*="pcDom"]');
        elements.forEach(element => {
          element.remove()
        });
      }else{
        const elements = document.querySelectorAll('[class*="moblieDom"]');
        elements.forEach(element => {
          element.remove()
        });
      }
  }
  if(document.querySelectorAll('[class*="pcDom"]').length>0){
    removePcClassesOnMobile();
  }
  const inputs = document.querySelectorAll('input[name="contact[tags]"]');
  inputs.forEach(input => {
    let phomemo_ads=localStorage.getItem("phomemo_ads");
    if(phomemo_ads){
        let tags=`newsletter,${phomemo_ads}`;
        input.value =tags;
    }
  });
});

	if (!customElements.get('search-form-header')) {
    class SearchFormHeader extends HTMLElement {
      constructor() {
        super();
        this.searchResultsDom=this.querySelector('.predictive-search-results');
        this.searchFormDom=this.querySelector('form');
        this.searchInputDom=this.querySelector('#header-search-input');
        this.initialSearchResultsHtml=this.querySelector('.predictive-search-results').innerHTML;
        this.searchInputDom.onfocus = (event) => {
          this.searchResultsDom.classList.add('active');
          const value = this.searchInputDom.value.trim();
          if (!value) {
             this.searchResultsDom.innerHTML = this.initialSearchResultsHtml;
          }
        };
        this.searchInputDom.onblur = (event) => {
          if (event.relatedTarget && event.relatedTarget.tagName === 'A') {
            return; 
          }
          this.searchResultsDom.classList.remove('active');
        };
        this.searchInputDom.addEventListener('input', this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this));
        this.placeholders = window.hotSearch;
        this.currentTextIndex = 0; 
        this.charIndex = 0;        
        this.isDeleting = false;  
        this.initEvents();
        this.startPlaceholderAnimation();
      }
      initEvents() {
        this.searchInputDom.onfocus = () => this.searchResultsDom.classList.add('active');
        this.searchInputDom.onblur = (event) => {
          const target = event.relatedTarget;
          if (target && target.closest('.predictive-search-results')) {
            return; 
          }
          if (target?.tagName === 'A') return;
          this.searchResultsDom.classList.remove('active');
        }
        this.searchFormDom.addEventListener('submit', (e) => {
          event.preventDefault();
          const value = this.searchInputDom.value.trim();
          if (!value) {
            if(gtagEvent){
              gtagEvent('placeholders_click')
            }
            window.location.href = this.placeholders[this.currentTextIndex].url;
          }
        });
      }   
      startPlaceholderAnimation() {
        const currentFullText = this.placeholders[this.currentTextIndex].title;
        if (!this.isDeleting) {
          this.searchInputDom.placeholder = currentFullText.substring(0, this.charIndex++);
          if (this.charIndex > currentFullText.length) {
            this.isDeleting = true;
            setTimeout(() => this.startPlaceholderAnimation(), 2000); // 展示完整词后停 2s
            return;
          }
        } else {
          this.searchInputDom.placeholder = currentFullText.substring(0, this.charIndex--);
          if (this.charIndex < 0) {
            this.isDeleting = false;
            this.currentTextIndex = (this.currentTextIndex + 1) % this.placeholders.length;
            this.charIndex = 0;
          }
        }
        const speed = this.isDeleting ? 50 : 150;
        setTimeout(() => this.startPlaceholderAnimation(), speed);
      }
      onChange() {
        const searchTerm = this.searchInputDom.value.trim();
        if (!searchTerm.length) {
          this.close();
          return;
        }
        this.getSearchResults(searchTerm);
      }
      getSearchResults(searchTerm) {
        fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search-2026`)
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              this.close();
              throw error;
            }

            return response.text();
          })
          .then((text) => {
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search-2026').innerHTML;
            this.searchResultsDom.innerHTML = resultsMarkup;
            this.open();
          })
          .catch((error) => {
            this.close();
            throw error;
          });
      }
      open() {
        this.searchResultsDom.classList.add('active');
        this.searchResultsDom.querySelector("#search-results-submit").addEventListener('click', () => {
          this.searchFormDom.submit()
        });
      }
      close() {
        this.searchResultsDom.innerHTML = this.initialSearchResultsHtml;
      }

      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }
    customElements.define('search-form-header', SearchFormHeader);
  }
(function() {
    if (window.location.search.includes('utm_source=ggads&utm_medium=cpc')) {
        localStorage.setItem('phomemo_ads', 'ggads_sub');
    }
    if (window.location.search.includes('utm_source=fb&utm_medium=ads')) {
        localStorage.setItem('phomemo_ads', 'fbads_sub');
    }
   
})();
function closeJpPopup() {
  const popupEl = document.getElementById('jp-popup-section');
  if (popupEl) {
    popupEl.style.display = 'none';
  }
}
document.addEventListener('DOMContentLoaded', () => {
  if(document.getElementById("jp-popup-section")){
    const POPUP_ID = 'jp-popup-section';
    const STORAGE_KEY = 'jp_popup_last_shown_date';
    const today = new Date().toISOString().split('T')[0]
    const lastShownDate = localStorage.getItem(STORAGE_KEY);
    if (lastShownDate !== today) {
      const popupEl = document.getElementById(POPUP_ID);
      if (popupEl) {
        popupEl.style.display = 'flex';
        localStorage.getItem(STORAGE_KEY) || localStorage.setItem(STORAGE_KEY, today);
      }
    }
    
  }
  
  const filterNameSpans = document.querySelectorAll('span.filter-name')
  if (filterNameSpans.length > 0) {
    filterNameSpans.forEach(filterNameSpan => {



      let contentToProcess = filterNameSpan.textContent;
      console.log("  Original textContent:", contentToProcess); // 调试输出

      const tempDiv = document.createElement('div');

      tempDiv.innerHTML = contentToProcess;
      let decodedContent = tempDiv.textContent;
      if (decodedContent.includes('&lt;') || decodedContent.includes('&gt;')) {
          tempDiv.innerHTML = decodedContent;
          decodedContent = tempDiv.textContent;
          console.log("  Decoded twice (innerHTML -> textContent):", decodedContent); // 调试输出
      }
      filterNameSpan.innerHTML = decodedContent;
      console.log("  Final innerHTML after processing:", filterNameSpan.innerHTML); // 调试输出
    });
    const existingStyle = document.head.querySelector('style#tc-style-fix');
    if (!existingStyle) {
        const styleElement = document.createElement('style');
        styleElement.id = 'tc-style-fix';
        styleElement.textContent = `
          tc {
            display: contents; /* 推荐：使其内容直接流动，但标签本身不生成任何盒子或布局 */
            /* color: purple; */ /* 可以添加一个颜色来测试它是否真的被解析成标签 */
          }
        `;
        document.head.appendChild(styleElement);
    }

  } else {
    console.warn("No elements with class 'filter-name' found on DOMContentLoaded.");
  }
});

